module.exports = __webpack_public_path__ + "static/media/two.b6d89d28.png";